import { requester } from "App";
import { createAction, createReducer, createSlice } from "@reduxjs/toolkit";
import { setLocalStorage, getTokenPayload } from "shared/utils/Utils";
import { toast } from "react-toastify";


export const CartReducer = createSlice({
    name: "Cart",
    initialState: {
        products: [],
        remainProducts: []  // Will now only contain {id, quantity}
    },
    reducers: {
        addProductToCart: (state, action) => {
            // alert("호출됨!!")
            const index = state.products.findIndex(product => product.id === action.payload.id);
            if (index !== -1) {
                // 상품이 이미 있으면 수량만 증가
                state.products[index].quantity += action.payload.quantity;
                // state.remainProducts[index].quantity += action.payload.quantity;
            } else {
                // 새 상품이면 배열에 추가
                state.products.push(action.payload);
                // state.remainProducts.push(action.payload);
            }
        },
        updateQuantity: (state, action) => {
            const { id, quantity} = action.payload;            
            const index = state.products.findIndex(product => product.id === id);
            if (index !== -1) {
                if (quantity !== undefined) {
                    state.products[index].quantity = quantity;
                }
            }
        },
        setRemainProducts: (state, action) => {
            // Only store id and quantity
            const remainProduct = {
                id: action.payload.id,
                productName: action.payload.productName,
                quantity: action.payload.quantity
            };
            
            const index = state.remainProducts.findIndex(product => product.id === remainProduct.id);

            if (index !== -1) {
                state.remainProducts[index].quantity += remainProduct.quantity;
            } else {
                state.remainProducts.push(remainProduct);
            }
        },
        updateRemainQuantity: (state, action) => {
            const { id, quantity} = action.payload;            
            const index = state.remainProducts.findIndex(product => product.id === id);
            if (index !== -1) {
                if (quantity !== undefined) {
                    state.remainProducts[index].quantity = quantity;
                }
            }
        },
        removeProductFromCart: (state, action) => {
            state.products = state.products.filter((product) => product.id !== action.payload.id);
        },
        removeRemainProductsFromCart: (state, action) => {
            state.remainProducts = state.remainProducts.filter((product) => product.id !== action.payload.id);
        },
        refreshCart: (state, action) => {
            state.products = action.payload;
        },
        reset: (state) => {
            state.products = [];
            state.remainProducts = [];
        },
        clearRemainProducts: (state) => {
            state.remainProducts = [];
        }
    },
});